import { configurationConstants } from '../constants/configurationConstants';

export const getSequenceColumns = (sequenceFor: string) => {
  const columns: any[] = [
    {
      title: 'SL No',
      dataIndex: 'key',
      width: 120,
    },
  ];

  columns.push(
    {
      title: 'Pipe Start',
      dataIndex: 'pipeStart',
      width: 120,
    },
    {
      title: 'Pipe ID',
      dataIndex: 'pipeId',
    },
    {
      title: 'Pipe End',
      dataIndex: 'pipeEnd',
      width: 120,
    },
    {
      title: 'Max HiLo',
      dataIndex: 'maxHilo',
      width: 120,
    },
    {
      title: 'TDC',
      dataIndex: 'tdc',
      width: 120,
    }
  );

  return columns.filter((col) => col.title);
};

export const generateSequenceData = (sequenceList: any[], spreadName: string) => {
  return (
    sequenceList?.map((ite: any) => {
      const slNo = Number(ite.SlNo);
      const ordinal = Number.isNaN(slNo) ? undefined : slNo + 1;

      return {
        key: ordinal ?? 0,
        spread2Column: ite.subSpread ? ite.subSpread : spreadName,
        sequenceLabel:
          typeof ite.sequenceNumber === 'number'
            ? `Sequence ${ite.sequenceNumber}`
            : ordinal
            ? `Sequence ${ordinal}`
            : undefined,
        sequenceId: ite.id,
        pipeStart: ite.pipeStart,
        pipeId: ite.pipeId,
        pipeEnd: ite.pipeEnd,
        maxHilo: Number(ite.maxHiLo)?.toFixed(2),
        tdc: Number(ite.tdc)?.toFixed(2),
      };
    }) || []
  );
};
